import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './end_user_index.routes';
import EndUserService from '../../../components/api/end_user/end_user.service';

export class EndUserIndexController {
  /*@ngInject*/
  constructor(EndUserService, $filter) {
    this.EndUserService = EndUserService;
    this.EndUserService.api.index((response) => {
      let adminList = $filter("filter")(response, {role: 'admin'}, true);
      let operatorList = $filter("filter")(response, {role: 'operator'}, true);
      let viewerList = $filter("filter")(response, {role: 'viewer'}, true);
      let limitedViewerList = $filter("filter")(response, {role: 'limited_viewer'}, true);

      this.userList = [adminList, operatorList, viewerList, limitedViewerList];
    });
  }

  $onInit() {
  }
}

export default angular.module('leptonApp.endUserIndex', [uiRouter, EndUserService])
  .config(routing)
  .component('endUserIndex', {
    template: require('./end_user_index.html'),
    controller: EndUserIndexController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/end_user/index/end_user_index.component.js